// Single source of truth for ISO2 → display name.
//
// Derived at module load from countries.json (the canonical 241-country list)
// via the browser's Intl.DisplayNames. Falls back to a small hand-curated map
// for exotic codes Intl doesn't recognise, and ultimately to the ISO2 itself.
//
// Replaces three copies of `const COUNTRY_NAMES = {...}` that had drifted
// across Directory.js, Events.js, and admin/EventsManagement.js.

import countries from './countries.json';

const FALLBACKS = {
  KV: 'Kosovo',
  UK: 'United Kingdom',
};

const resolve = (code) => {
  const upper = (code || '').toUpperCase();
  if (!upper) return '';
  try {
    const dn = new Intl.DisplayNames(['en'], { type: 'region' });
    const name = dn.of(upper);
    if (name && name !== upper) return name;
  } catch {
    // Intl.DisplayNames unavailable — fall through.
  }
  return FALLBACKS[upper] || upper;
};

// Pre-compute once at module load so the ISO2 keys known to be supported
// still work as a plain object lookup in legacy call sites.
const COUNTRY_NAMES = Object.keys(countries).reduce((acc, iso2) => {
  acc[iso2] = resolve(iso2);
  return acc;
}, {});

export default COUNTRY_NAMES;
export { resolve as countryName };
